(function () {
  function initEz2GetStaffIntake() {
    if (window.location.pathname !== '/pages/sales-order-intake') return;

    var staffCodes = Object.freeze({
      'ALEXIS-2746': 'Alexis',
      'ELENA-3462': 'Elena',
      'LILI-7284': 'Lili',
      'JORGE-8172': 'Jorge',
      'JASMINE-5777': 'Jasmine'
    });
    var formUrl = 'https://api.leadconnectorhq.com/widget/survey/mpc09CWMwUAZKuRDwToz';
    var input = document.getElementById('ez2get-staff-pin');
    var submit = document.getElementById('ez2get-staff-submit');
    var error = document.getElementById('ez2get-pin-error');
    var gate = document.getElementById('ez2-staff-gate');
    var content = document.getElementById('ez2-staff-content');
    var banner = document.getElementById('ez2get-rep-banner');
    var change = document.getElementById('ez2get-change-staff');
    var frame = document.getElementById('ez2get-intake-frame');
    var shell = document.getElementById('ez2-staff-shell');
    if (!input || !submit || !error || !gate || !content || !banner || !change || !frame || !shell) return;

    var robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex,nofollow,noarchive';

    function unlock(rep) {
      window.sessionStorage.setItem('ez2getStaffRep', rep);
      gate.hidden = true;
      content.hidden = false;
      shell.style.display = 'block';
      banner.textContent = 'Signed in as: ' + rep;
      var url = new URL(formUrl);
      url.searchParams.set('rep', rep);
      url.searchParams.set('source', 'shopify_staff_intake');
      frame.src = url.toString();
      window.scrollTo(0, 0);
    }

    function verifyCode() {
      var value = input.value ? input.value.trim().toUpperCase() : '';
      var rep = staffCodes[value];
      if (!rep) {
        error.textContent = 'Code not recognized. Ask the manager for your assigned code.';
        input.focus();
        return;
      }
      error.textContent = '';
      unlock(rep);
    }

    submit.addEventListener('click', verifyCode);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        verifyCode();
      }
    });
    change.addEventListener('click', function () {
      window.sessionStorage.removeItem('ez2getStaffRep');
      window.location.reload();
    });

    var savedRep = window.sessionStorage.getItem('ez2getStaffRep');
    if (savedRep && Object.values(staffCodes).indexOf(savedRep) !== -1) unlock(savedRep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEz2GetStaffIntake, { once: true });
  } else {
    initEz2GetStaffIntake();
  }
}());
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



(function () {
  function brandEz2GetStaffGate() {
    if (window.location.pathname !== '/pages/sales-order-intake') return;

    if (!document.getElementById('ez2get-staff-brand-styles')) {
      var styles = document.createElement('style');
      styles.id = 'ez2get-staff-brand-styles';
      styles.textContent = [
        '.ez2get-staff-gate{min-height:100dvh!important;padding:28px 16px!important;box-sizing:border-box!important;background:radial-gradient(circle at 20% 10%,#123b70 0,#061a34 52%,#03101f 100%)!important;overflow:auto!important}',
        '.ez2get-staff-gate .ez2get-staff-card{position:relative!important;overflow:hidden!important;width:min(660px,100%)!important;max-width:660px!important;padding:44px 44px 40px!important;box-sizing:border-box!important;border:1px solid rgba(255,255,255,.28)!important;border-top:6px solid #f1141a!important;border-radius:28px!important;background:linear-gradient(145deg,#0647b7 0%,#075fd4 58%,#008cff 100%)!important;box-shadow:0 28px 75px rgba(0,70,176,.42)!important;color:#fff!important}',
        '.ez2get-staff-gate .ez2get-staff-card:before{content:""!important;position:absolute!important;width:320px!important;height:320px!important;right:-150px!important;top:-190px!important;border-radius:50%!important;background:rgba(255,255,255,.16)!important;pointer-events:none!important}',
        '.ez2get-staff-logo{position:relative!important;z-index:3!important;display:block!important;width:126px!important;height:126px!important;object-fit:contain!important;margin:4px auto 22px!important;filter:drop-shadow(0 12px 22px rgba(0,0,0,.30))!important}',
        '.ez2get-staff-gate .ez2get-staff-kicker{position:relative!important;z-index:2!important;color:#fff!important}',
        '.ez2get-staff-gate .ez2get-staff-card h1,.ez2get-staff-gate .ez2get-staff-card>p{position:relative!important;z-index:2!important;color:#fff!important}',
        '.ez2get-staff-gate #ez2get-staff-pin{position:relative!important;z-index:2!important;border:3px solid #f1141a!important;background:#fff!important;color:#10233f!important}',
        '.ez2get-staff-gate .ez2get-staff-button{position:relative!important;z-index:2!important;background:linear-gradient(135deg,#f1141a,#c90009)!important;box-shadow:0 14px 34px rgba(174,0,8,.40)!important}',
        '.ez2get-staff-gate .ez2get-staff-help{color:#e8f3ff!important}',
        '#ez2get-staff-content .ez2-repbar{display:none!important}',
        'html,html body,#ez2get-staff-content,#ez2-staff-shell{background:linear-gradient(180deg,#071b33 0%,#0a315b 55%,#061a34 100%)!important}',
        '#ez2get-intake-frame.ez2-frame{display:block!important;width:100%!important;height:820px!important;min-height:0!important;max-height:820px!important;margin:0!important}',
        '@media(max-width:640px){#ez2get-intake-frame.ez2-frame{display:block!important;width:100%!important;height:calc(100dvh - 110px)!important;min-height:720px!important;max-height:none!important;margin:0!important}}',
        '@media(max-width:640px){.ez2get-staff-gate{min-height:auto!important;display:block!important;padding:16px 12px 20px!important;align-items:initial!important}.ez2get-staff-gate .ez2get-staff-card{padding:34px 20px 30px!important;border-radius:22px!important}.ez2get-staff-logo{width:108px!important;height:108px!important;margin:2px auto 18px!important}.ez2get-staff-gate .ez2get-staff-card h1{font-size:32px!important;line-height:1.08!important}}'
      ].join('');
      document.head.appendChild(styles);
    }

    var card = document.querySelector('.ez2get-staff-gate .ez2get-staff-card');
    if (card && !card.querySelector('.ez2get-staff-logo')) {
      var logo = document.createElement('img');
      logo.className = 'ez2get-staff-logo';
      logo.src = 'https://easy2getfurniture.com/cdn/shop/files/EZ_Logo_96x96.png?v=1677625236';
      logo.alt = 'EZ2GET Furniture';
      logo.width = 126;
      logo.height = 126;
      card.insertBefore(logo, card.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brandEz2GetStaffGate, { once: true });
  } else {
    brandEz2GetStaffGate();
  }
}());


(function () {
  function finishEz2GetStaffGate() {
    if (window.location.pathname !== '/pages/sales-order-intake') return;

    var cleanupStyles = document.createElement('style');
    cleanupStyles.id = 'ez2get-staff-page-cleanup';
    cleanupStyles.textContent = '#chatra__iframe,.chatra--webkit,.chatra--side-bottom,.chatra--side-right{display:none!important;visibility:hidden!important;pointer-events:none!important}';
    if (!document.getElementById(cleanupStyles.id)) document.head.appendChild(cleanupStyles);

    var heading = document.querySelector('.ez2get-staff-gate .ez2get-staff-card h1');
    var intro = heading ? heading.nextElementSibling : null;
    if (intro && intro.tagName === 'P') {
      intro.textContent = '1. Enter your code.  2. Complete the order exactly as sold.  3. Submit once and notify the manager.';
      intro.setAttribute('aria-label', 'Enter your code, complete the order exactly as sold, submit once, and notify the manager.');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', finishEz2GetStaffGate, { once: true });
  } else {
    finishEz2GetStaffGate();
  }
}());
